import React, { useEffect } from "react";
import { Box, Card, Typography, useTheme, useMediaQuery } from "@mui/material";

export default function Gagarin() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    // Function to process Instagram embeds
    const processEmbeds = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };

    // Load Instagram embed script if not already loaded
    if (!document.getElementById("instagram-embed-script")) {
      const script = document.createElement("script");
      script.id = "instagram-embed-script";
      script.src = "//www.instagram.com/embed.js";
      script.async = true;
      script.onload = processEmbeds;
      document.body.appendChild(script);
    } else {
      processEmbeds();
    }
  }, [isMobile]); // Re-run when view changes

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start", // Move to top
        minHeight: "80vh",
        pt: 8, // Add top padding to position it slightly down from very top
        pb: 4,
        background: "linear-gradient(to right, #ece9e6, #ffffff)",
      }}
    >
      <Typography 
        variant="h4" 
        component="h1" 
        align="center"
        sx={{ 
          mb: 4, 
          fontWeight: 600, 
          color: "#2c3e50",
          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          letterSpacing: "0.05em",
          // textTransform: "uppercase", // Removed to keep exact casing
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)"
        }}
      >
        Ю. Гагарин ат. СГТУ Ресурс центрі
      </Typography>

      <Card 
        elevation={10} 
        sx={{ 
          borderRadius: 4, 
          overflow: "hidden", 
          maxWidth: 800, // Increased width
          width: "100%",
          display: "flex",
          justifyContent: "center",
          p: 2,
          bgcolor: "background.paper"
        }}
      >
        <blockquote
          key={isMobile ? "mobile" : "desktop"} // Force re-render on breakpoint change
          className="instagram-media"
          data-instgrm-captioned={!isMobile ? "" : undefined} // Show captions only on non-mobile
          data-instgrm-permalink="https://www.instagram.com/reel/Cs4Vp4vgiVs/?utm_source=ig_embed&ig_rid=b54e3d7f-edbe-46ac-9998-585ca2427fad"
          data-instgrm-version="14"
          style={{
            background: "#FFF",
            border: 0,
            borderRadius: 3,
            boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
            margin: 1,
            maxWidth: 780, // Adjusted inner max-width
            minWidth: 326,
            padding: 0,
            width: "calc(100% - 2px)",
          }}
        >
        </blockquote>
      </Card>

    </Box>
  );
}
